import { Component, Inject } from '@angular/core';
import { helper } from 'src/environments/helper';
import { AwbDocument, AwbDocumentDetail, AwbEntity, DocumentData, DocumentDataIesire, EntityDocument, GeneralData } from '../../../document.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, debounceTime, distinctUntilChanged, finalize, map, Observable, of, Subject, switchMap, takeUntil, tap, throwError } from 'rxjs';
import { SearchEntitate } from 'src/app/components/entitati/entitati.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ToastService } from 'src/app/services/toast.service';
import { formatDate } from '@angular/common';
import { DashboardService } from '../../../dashboard.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-add-awb',
    templateUrl: './add-awb.component.html',
    styleUrls: ['./add-awb.component.scss']
})
export class AddAwbComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;

    step: number = 1;
    entitateType: number = 0;  // 0 - default; 1 - extern; 2 - alte destinatii

    generalData!: GeneralData[];
    docData!: DocumentData;
    awbData: AwbDocument | null = null;
    entityData: AwbEntity | EntityDocument | null = null;
    foundAWB: AwbDocumentDetail | null = null;
    onlyView: boolean = false;

    showSelectedDocs: boolean = true;
    selectedDocuments: DocumentDataIesire[] = [];
    selectedDocumentsNr: number = 0;
    conexeDocuments: DocumentDataIesire[] = [];

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    statusPostaOptions: Generic[] = [];

    statusIndocOptions: Generic[] = [];

    formExtern: FormGroup = new FormGroup({
        id_address_type: new FormControl('', []),
        denumire: new FormControl('', [Validators.required]),
        cnp_cui: new FormControl('', []),
        email: new FormControl('', []),
        telefon: new FormControl('', []),
        id_tara: new FormControl(null, [Validators.required]),
        name_tara: new FormControl('', [Validators.required]),
        id_judet: new FormControl(null, [Validators.required]),
        name_judet: new FormControl('', [Validators.required]),
        id_localitate: new FormControl(null, [Validators.required]),
        name_localitate: new FormControl('', [Validators.required]),
        sector: new FormControl('-1', []),
        id_strada: new FormControl(null, [Validators.required]),
        name_strada: new FormControl('', [Validators.required]),
        numar: new FormControl('', []),
        bloc: new FormControl('', []),
        scara: new FormControl('', []),
        apartament: new FormControl('', []),
        cod_postal: new FormControl('', []),
        extern_entity: new FormControl(0, []),
    })

    formFilters: FormGroup = new FormGroup({
        id_serie: new FormControl(-1, []),
        destinatar: new FormControl(null, []),
        numar_document: new FormControl(null, []),
        data_inregistrare: new FormControl('', []),
        // data_inregistrare_formated: new FormControl('', []), // Added in search!
        tip_document: new FormControl(null, [Validators.required]),
        // name_tip_document: new FormControl('', []),
        cnp_cui: new FormControl('', []),
        // document_id: new FormControl(null, []), // Added in search!
    });

    form: FormGroup = new FormGroup({
        greutate: new FormControl(null, []),
        id_borderou: new FormControl(null, []),
        continut: new FormControl('', [Validators.required]),
        observatii: new FormControl('', []),
        status_posta: new FormControl('', []),
        status: new FormControl('', []),
    });

    private destroy$ = new Subject<void>();

    serii: Generic[] = [];

    entitatiExtern: SearchEntitate[] = [];
    entitatiExternControl: FormControl<any> = new FormControl('', [Validators.required]);
    isEntitatiExternLoading = false;
    showEntitatiExternMessage = true;
    entitatiExternLoadComplete = false;

    tariExtern: Generic[] = [];
    filteredTariExtern: Generic[] = [];
    tariExternControl: FormControl<any> = new FormControl('', [Validators.required]);

    judeteExtern: Generic[] = [];
    filteredJudeteExtern: Generic[] = [];
    judeteExternControl: FormControl<any> = new FormControl('', [Validators.required]);

    localitatiExtern: Generic[] = [];
    localitatiExternControl: FormControl<any> = new FormControl('', [Validators.required]);
    isLocalitatiExternLoading = false;
    showLocalitatiExternMessage = true;
    localitatiExternLoadComplete = false;

    straziExtern: Generic[] = [];
    straziExternControl: FormControl<any> = new FormControl('', [Validators.required]);
    isStraziExternLoading = false;
    showStraziExternMessage = true;
    straziExternLoadComplete = false;
    lastStraziExternValue = '';

    entitatiFilters: SearchEntitate[] = [];
    entitatiFiltersControl: FormControl<any> = new FormControl();
    isEntitatiFiltersLoading = false;
    showEntitatiFiltersMessage = true;
    entitatiFiltersLoadComplete = false;

    tipDocumente: Generic[] = [];
    tipDocumenteControl = new FormControl('', [Validators.required]);
    isTipDocumenteLoading = false;
    showTipDocumenteMessage = true;
    tipDocumenteLoadComplete = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            generalData: GeneralData[],
            docData: DocumentData,
            awbData?: AwbDocument
            onlyView?: boolean;
        },
        private dialogRef: MatDialogRef<AddAwbComponent>,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
        private toastService: ToastService,
    ) {
        this.generalData = data.generalData;
        this.docData = data.docData;

        if (data.awbData !== undefined) {
            this.step = 2;
            this.awbData = data.awbData;
            this.entitateType = this.awbData.entity.extern_entity;
            this.formExtern.controls['extern_entity'].patchValue(this.entitateType);

            // Get the entity data from awbData when updating AWBs
            this.entityData = this.awbData.entity;
        } else {
            this.step = 1;
        }

        if (data.onlyView) {
            this.onlyView = data.onlyView;

            this.formExtern.disable();
            this.entitatiExternControl.disable();
            this.tariExternControl.disable();
            this.localitatiExternControl.disable();
            this.judeteExternControl.disable();
            this.straziExternControl.disable();
            this.formFilters.disable();
            this.entitatiFiltersControl.disable();
            this.tipDocumenteControl.disable();
            this.form.disable();
        }
    }

    ngOnInit() {
        this.loadTariActive();
        this.loadSeriiActive();
        this.loadStatusesActive();
        this.loadStatusPostaActive();

        // Load entitate data
        if (this.entityData) this.updateFormEmitentExtern(this.entityData);

        if (this.awbData) {
            // Update form when updating the awb
            this.form.patchValue({
                greutate: this.awbData.greutate,
                id_borderou: this.awbData.id_borderou,
                continut: this.awbData.continut,
                observatii: this.awbData.observatii,
                status_posta: this.awbData.status_posta,
                status: this.awbData.status,
            });
            this.findAWB(this.awbData.id);
        } else {
            // Update form when storing a new awb
            const foundGreutate = this.generalData.find(item => item.name === 'greutate')
            const foundBorderouActiv = this.generalData.find(item => item.name === 'BORDEROU_ACTIV')
            const foundStatusPosta = this.generalData.find(item => item.name === 'status_posta')
            const foundStatusIndoc = this.generalData.find(item => item.name === 'status_indoc')
            this.form.patchValue({
                greutate: foundGreutate ? Number(foundGreutate.value) : null,
                id_borderou: foundBorderouActiv ? Number(foundBorderouActiv.value) : null,
                status_posta: foundStatusPosta ? Number(foundStatusPosta.value) : null,
                status: foundStatusIndoc ? Number(foundStatusIndoc.value) : null,
            });
        }

        this.entitatiExternControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiExtern(value);
                this.showEntitatiExternMessage = true;
                this.entitatiExternLoadComplete = false;
            }
        });

        this.localitatiExternControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(localitate => {
            if (typeof localitate === 'string') {
                this.fetchLocalitatiExtern(localitate);
                this.showLocalitatiExternMessage = true;
                this.localitatiExternLoadComplete = false;
            }
        });

        this.straziExternControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(strada => {
            if (typeof strada === 'string') {
                this.fetchStraziExtern(strada);
                this.showStraziExternMessage = true;
                this.straziExternLoadComplete = false;
            }
        });

        this.entitatiFiltersControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiFilters(value);
                this.showEntitatiFiltersMessage = true;
                this.entitatiFiltersLoadComplete = false;
            }
        });

        this.tipDocumenteControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchTipDocumente(value);
                this.showTipDocumenteMessage = true;
                this.tipDocumenteLoadComplete = false;
            }
        });

        this.renderFieldsSearch();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    chooseEntityType(type: number) {
        this.step = 2;
        this.entitateType = type;

        switch (this.entitateType) {
            case 0:
                this.entityData = this.docData.entity;
                this.formExtern.controls['extern_entity'].patchValue(0);
                break;
            case 1:
                this.entityData = this.docData.entity_emitent_extern;
                this.formExtern.controls['extern_entity'].patchValue(1);
                break;
            default:
                this.entityData = null;
                this.formExtern.controls['extern_entity'].patchValue(0);
        }

        // Load entitate data
        if (this.entityData) this.updateFormEmitentExtern(this.entityData);
    }

    // START -- Methods for getting data -- START
    renderFieldsSearch() {
        this.tariExternControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.tariExtern);
                }
                if (inputValue.length < 1) {
                    this.filteredTariExtern = this.tariExtern;
                    return of(this.tariExtern);
                }
                return this.filterTariExtern(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredTariExtern = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.judeteExternControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.judeteExtern);
                }
                if (inputValue.length < 1) {
                    this.filteredJudeteExtern = this.judeteExtern;
                    return of(this.judeteExtern);
                }
                return this.filterJudeteExtern(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredJudeteExtern = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    findAWB(id: number) {
        this.isLoading = true;
        this.dashboardService
            .findAWB(id)
            .pipe(
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.foundAWB = results.data;
                    // Add conexe
                    this.conexeDocuments = this.foundAWB.conex_documents_records.map(doc => { return { ...doc, selected: true, } });
                },
                error: (error) => {
                    console.error('Error loading surse', error);
                    this.isLoading = false;
                },
            });
    }

    loadTariActive() {
        this.isLoading = true;
        this.commonService
            .getTariActive()
            .pipe(
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.tariExtern = results;
                    this.filteredTariExtern = [...this.tariExtern];
                },
                error: (error) => {
                    console.error('Error loading tari', error);
                    this.filteredTariExtern = [];
                },
            });
    }

    loadSeriiActive() {
        this.isLoading = true;
        this.commonService
            .getSeriiActive()
            .pipe(
                map((resp: Generic[]) => [this.defaultParameter, ...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.serii = results;
                },
                error: (error) => {
                    console.error('Error loading surse', error);
                    this.isLoading = false;
                },
            });
    }

    loadStatusesActive() {
        this.isLoading = true;
        this.commonService
            .getStatusesActive()
            .pipe(
                takeUntil(this.destroy$),
                map((results: Generic[]) => [this.defaultParameter, ...results]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.statusIndocOptions = results;
                },
                error: (error) => {
                    console.error('Error loading request statuses', error);
                    this.isLoading = false;
                },
            });
    }

    loadStatusPostaActive() {
        this.isLoading = true;
        this.commonService
            .getStatusPostaActive()
            .pipe(
                takeUntil(this.destroy$),
                map((results: Generic[]) => [this.defaultParameter, ...results]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.statusPostaOptions = results;
                },
                error: (error) => {
                    console.error('Error loading request status posta', error);
                    this.isLoading = false;
                },
            });
    }

    fetchEntitatiExtern(entitate: string) {
        if (entitate && entitate.length >= 2) {
            this.isEntitatiExternLoading = true;

            const route = this.entitateType === 1 ? this.commonService.searchEntitatiExtern(entitate) : this.commonService.searchEntitati(entitate);

            route.subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiExtern = response;
                    this.isEntitatiExternLoading = false;
                    this.entitatiExternLoadComplete = true;
                    this.showEntitatiExternMessage = this.entitatiExtern.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiExternLoading = false;
                    this.showEntitatiExternMessage = true;
                    this.entitatiExternLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiExtern = [];
            this.showEntitatiExternMessage = true;
            this.entitatiExternLoadComplete = false;
        }
    }

    onEntitateExternSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitentExtern(selectedEntitate);
        }
    }

    displayEntitateExtern(entitate: SearchEntitate): string {
        return entitate && entitate.denumire ? entitate.denumire : '';
    }

    onEntitateExternChange() {
        const currentValue = this.entitatiExternControl.value;

        if (typeof currentValue === 'string') {
            this.formExtern.controls['denumire'].patchValue(currentValue);
        }
    }

    updateFormEmitentExtern(selectedEntitate: SearchEntitate | EntityDocument | AwbEntity) {
        this.entitatiExternControl.setValue(selectedEntitate);
        this.formExtern.get('denumire')?.patchValue(selectedEntitate.denumire);
        this.formExtern.get('email')?.patchValue(selectedEntitate.email);
        this.formExtern.get('telefon')?.patchValue(selectedEntitate.telefon);

        this.formExtern.get('id_address_type')?.patchValue(selectedEntitate.id_address_type);
        this.formExtern.get('cnp_cui')?.patchValue(selectedEntitate.cnp_cui);

        if (selectedEntitate.id_tara && selectedEntitate.name_tara) {
            this.tariExternControl.setValue({
                id: selectedEntitate.id_tara,
                name: selectedEntitate.name_tara
            })
            this.formExtern.get('id_tara')?.patchValue(selectedEntitate.id_tara);
            this.formExtern.get('name_tara')?.patchValue(selectedEntitate.name_tara);
            this.loadJudeteExtern(selectedEntitate.id_tara);
        }
        if (selectedEntitate.id_judet && selectedEntitate.name_judet) {
            this.judeteExternControl.setValue({
                id: selectedEntitate.id_judet,
                name: selectedEntitate.name_judet
            })
            this.formExtern.get('id_judet')?.patchValue(selectedEntitate.id_judet);
            this.formExtern.get('name_judet')?.patchValue(selectedEntitate.name_judet);
        }
        if (selectedEntitate.id_localitate && selectedEntitate.name_localitate) {
            this.fetchLocalitatiExtern(selectedEntitate.name_localitate);
            this.localitatiExternControl.setValue({
                id: selectedEntitate.id_localitate,
                name: selectedEntitate.name_localitate
            })
            this.formExtern.get('id_localitate')?.patchValue(selectedEntitate.id_localitate);
            this.formExtern.get('name_localitate')?.patchValue(selectedEntitate.name_localitate);
        }
        if (selectedEntitate.id_strada && selectedEntitate.name_strada) {
            this.fetchStraziExtern(selectedEntitate.name_strada);
            this.straziExternControl.setValue({
                id: selectedEntitate.id_strada,
                name: selectedEntitate.name_strada
            })
            this.formExtern.get('id_strada')?.patchValue(selectedEntitate.id_strada);
            this.formExtern.get('name_strada')?.patchValue(selectedEntitate.name_strada);
        }

        this.formExtern.get('sector')?.patchValue(selectedEntitate.sector);
        this.formExtern.get('numar')?.patchValue(selectedEntitate.numar);
        this.formExtern.get('bloc')?.patchValue(selectedEntitate.bloc);
        this.formExtern.get('scara')?.patchValue(selectedEntitate.scara);
        this.formExtern.get('apartament')?.patchValue(selectedEntitate.apartament);
        this.formExtern.get('cod_postal')?.patchValue(selectedEntitate.cod_postal);
    }

    onTariExternChange(selectedTara: Generic): void {
        this.formExtern.controls['id_tara'].patchValue(selectedTara.id);
        this.formExtern.controls['name_tara'].patchValue(selectedTara.name);

        this.loadJudeteExtern(selectedTara.id);
        this.judeteExternControl.patchValue('');
        this.formExtern.controls['id_judet'].patchValue('');
        this.formExtern.controls['name_judet'].patchValue('');

        this.localitatiExternControl.patchValue('');
        this.formExtern.controls['id_localitate'].patchValue('');
        this.formExtern.controls['name_localitate'].patchValue('');

        this.straziExternControl.patchValue('');
        this.formExtern.controls['id_strada'].patchValue('');
        this.formExtern.controls['name_strada'].patchValue('');
    }

    displayTariExtern(selectedTara: Generic): string {
        return selectedTara && selectedTara.name ? selectedTara.name : '';
    }

    onTariExternBlur() {
        const currentValue = this.tariExternControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tariExternControl.patchValue('');
            this.formExtern.controls['id_tara'].patchValue('');
            this.formExtern.controls['name_tara'].patchValue('');

            this.judeteExtern = [];
            this.filteredJudeteExtern = [];
            this.judeteExternControl.patchValue('');
            this.formExtern.controls['id_judet'].patchValue('');
            this.formExtern.controls['name_judet'].patchValue('');

            this.localitatiExternControl.patchValue('');
            this.formExtern.controls['id_localitate'].patchValue('');
            this.formExtern.controls['name_localitate'].patchValue('');

            this.straziExternControl.patchValue('');
            this.formExtern.controls['id_strada'].patchValue('');
            this.formExtern.controls['name_strada'].patchValue('');
        }
    }

    loadJudeteExtern(taraId?: number) {
        this.isLoading = true;
        this.commonService
            .getJudeteActive(taraId)
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.judeteExtern = results;
                    this.filteredJudeteExtern = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                    this.filteredJudeteExtern = [];
                },
            });
    }

    onJudeteExternChange(selectedJudet: Generic): void {
        this.formExtern.controls['id_judet'].patchValue(selectedJudet.id);
        this.formExtern.controls['name_judet'].patchValue(selectedJudet.name);

        this.localitatiExternControl.patchValue('');
        this.formExtern.controls['id_localitate'].patchValue('');
        this.formExtern.controls['name_localitate'].patchValue('');

        this.straziExternControl.patchValue('');
        this.formExtern.controls['id_strada'].patchValue('');
        this.formExtern.controls['name_strada'].patchValue('');
    }

    displayJudeteExtern(selectedJudet: Generic): string {
        return selectedJudet && selectedJudet.name ? selectedJudet.name : '';
    }

    onJudeteExternBlur() {
        const currentValue = this.judeteExternControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.judeteExternControl.patchValue('');
            this.formExtern.controls['id_judet'].patchValue('');
            this.formExtern.controls['name_judet'].patchValue('');

            this.localitatiExternControl.patchValue('');
            this.formExtern.controls['id_localitate'].patchValue('');
            this.formExtern.controls['name_localitate'].patchValue('');

            this.straziExternControl.patchValue('');
            this.formExtern.controls['id_strada'].patchValue('');
            this.formExtern.controls['name_strada'].patchValue('');
        }
    }

    fetchLocalitatiExtern(localitate: string) {
        const taraExternValue = this.formExtern.get('id_tara')?.value;
        const judetExternValue = this.formExtern.get('id_judet')?.value;
        const tara = taraExternValue && taraExternValue !== -1 ? this.formExtern.get('id_tara')?.value : undefined;
        const judet = judetExternValue && judetExternValue !== -1 ? this.formExtern.get('id_judet')?.value : undefined;
        if (localitate.length >= 2) {
            this.isLocalitatiExternLoading = true;
            this.commonService.getLocalitatiActive(tara, judet, localitate).subscribe({
                next: (response: any) => {
                    this.localitatiExtern = response;
                    this.isLocalitatiExternLoading = false;
                    this.localitatiExternLoadComplete = true;
                    this.showLocalitatiExternMessage = this.localitatiExtern.length === 0;
                },
                error: (err: any) => {
                    this.isLocalitatiExternLoading = false;
                    this.showLocalitatiExternMessage = true;
                    this.localitatiExternLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.localitatiExtern = [];
            this.showLocalitatiExternMessage = true;
            this.localitatiExternLoadComplete = false;
        }
    }

    onLocalitatiExternSelected(selectedLocalitate: Generic) {
        if (selectedLocalitate) {
            this.formExtern.controls['id_localitate'].patchValue(selectedLocalitate.id);
            this.formExtern.controls['name_localitate'].patchValue(selectedLocalitate.name);
        }
    }

    displayLocalitatiExtern(selectedLocalitate: Generic): string {
        return selectedLocalitate && selectedLocalitate.name ? selectedLocalitate.name : '';
    }

    onLocalitatiExternBlur() {
        const currentValue = this.localitatiExternControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.localitatiExternControl.patchValue('');
            this.formExtern.controls['id_localitate'].patchValue('');
            this.formExtern.controls['name_localitate'].patchValue('');

            this.straziExternControl.patchValue('');
            this.formExtern.controls['id_strada'].patchValue('');
            this.formExtern.controls['name_strada'].patchValue('');
        }
    }

    fetchStraziExtern(strada: string) {
        this.fetchStraziExternObservable(strada).subscribe();
    }

    private fetchStraziExternObservable(strada: string) {
        const taraExternValue = this.formExtern.get('id_tara')?.value;
        const judetExternValue = this.formExtern.get('id_judet')?.value;
        const localitateExternValue = this.formExtern.get('id_localitate')?.value;
        const tara = taraExternValue && taraExternValue !== -1 ? taraExternValue : undefined;
        const judet = judetExternValue && judetExternValue !== -1 ? judetExternValue : undefined;
        const localitate = localitateExternValue && localitateExternValue !== -1 ? localitateExternValue : undefined;

        if (strada.length >= 2) {
            this.lastStraziExternValue = strada;
            this.isStraziExternLoading = true;

            return this.commonService.getStraziActive(tara, judet, localitate, strada).pipe(
                takeUntil(this.destroy$),
                tap((response: any) => {
                    this.straziExtern = response;
                    this.isStraziExternLoading = false;
                    this.straziExternLoadComplete = true;
                    this.showStraziExternMessage = this.straziExtern.length === 0;
                }),
                catchError((err: any) => {
                    this.isStraziExternLoading = false;
                    this.showStraziExternMessage = true;
                    this.straziExternLoadComplete = true;
                    console.log(err);
                    return throwError(() => err);
                })
            );
        } else {
            this.straziExtern = [];
            this.showStraziExternMessage = true;
            this.straziExternLoadComplete = false;
            return of([]);
        }
    }

    onStraziExternSelected(selectedStrada: Generic) {
        if (selectedStrada) {
            this.formExtern.controls['id_strada'].patchValue(selectedStrada.id);
            this.formExtern.controls['name_strada'].patchValue(selectedStrada.name);
        }
    }

    displayStraziExtern(selectedStrada: Generic): string {
        return selectedStrada && selectedStrada.name ? selectedStrada.name : '';
    }

    onStraziExternBlur() {
        setTimeout(() => {
            const currentValue = this.straziExternControl.value;

            // If the value is a string (not an object), it means user didn't select from list
            if (typeof currentValue === 'string') {
                this.straziExternControl.patchValue('');
                this.formExtern.controls['id_strada'].patchValue('');
                this.formExtern.controls['name_strada'].patchValue('');
                this.lastStraziExternValue = '';
            }
        }, 2000)
    }

    addStraziExtern() {
        this.isLoading = true;
        const payload = {
            name: this.lastStraziExternValue,
            id_country: this.formExtern.get('id_tara')?.value,
            id_judet: this.formExtern.get('id_judet')?.value,
            id_localitate: this.formExtern.get('id_localitate')?.value,
        }

        // console.log(payload);
        this.commonService.storeStrada(payload)
            .pipe(
                switchMap(() => this.fetchStraziExternObservable(this.lastStraziExternValue)),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: () => {
                    // Run fetchStraziExtern first then fill the input with the new street data
                    if (this.straziExtern && this.straziExtern.length > 0) {
                        const foundStrada = this.straziExtern[0];
                        this.straziExternControl.setValue(foundStrada);
                        this.formExtern.controls['id_strada'].patchValue(foundStrada.id);
                        this.formExtern.controls['name_strada'].patchValue(foundStrada.name);
                    }
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }


    fetchEntitatiFilters(entitate: string) {
        if (entitate && entitate.length >= 2) {
            this.isEntitatiFiltersLoading = true;
            this.commonService.searchEntitati(entitate).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiFilters = response;
                    this.isEntitatiFiltersLoading = false;
                    this.entitatiFiltersLoadComplete = true;
                    this.showEntitatiFiltersMessage = this.entitatiFilters.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiFiltersLoading = false;
                    this.showEntitatiFiltersMessage = true;
                    this.entitatiFiltersLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiFilters = [];
            this.showEntitatiFiltersMessage = true;
            this.entitatiFiltersLoadComplete = false;
        }
    }

    onEntitateFiltersSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitentFilters(selectedEntitate);
        }
    }

    displayEntitateFilters(entitate: SearchEntitate): string {
        return entitate && entitate.denumire ? entitate.denumire : '';
    }

    onEntitateFiltersBlur() {
        const currentValue = this.entitatiFiltersControl.value;

        if (typeof currentValue === 'string') {
            this.entitatiFiltersControl.patchValue('');
            this.formFilters.controls['destinatar'].patchValue(null);
        }
    }

    updateFormEmitentFilters(selectedEntitate: SearchEntitate) {
        this.formFilters.get('destinatar')?.patchValue(selectedEntitate.id);
        // this.formFilters.get('cnp_cui')?.patchValue(selectedEntitate.cnp_cui);
    }

    fetchTipDocumente(search: string) {
        if (search && search.length >= 2) {
            this.isTipDocumenteLoading = true;
            this.commonService.searchTipDocumente(search).subscribe({
                next: (response: Generic[]) => {
                    this.tipDocumente = response;
                    this.isTipDocumenteLoading = false;
                    this.tipDocumenteLoadComplete = true;
                    this.showTipDocumenteMessage = this.tipDocumente.length === 0;
                },
                error: (err: any) => {
                    this.isTipDocumenteLoading = false;
                    this.showTipDocumenteMessage = true;
                    this.tipDocumenteLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.tipDocumente = [];
            this.showTipDocumenteMessage = true;
            this.tipDocumenteLoadComplete = false;
        }
    }

    onTipDocumenteSelected(selectedDocument: Generic) {
        if (selectedDocument) {
            this.formFilters.controls['tip_document'].patchValue(selectedDocument.id);
            // this.formFilters.controls['name_tip_document'].patchValue(selectedDocument.name);
        }
    }

    displayTipDocumente(selectedDocument: Generic): string {
        return selectedDocument && selectedDocument.name ? selectedDocument.name : '';
    }

    onTipDocumenteBlur() {
        const currentValue = this.tipDocumenteControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tipDocumenteControl.patchValue('');
            this.formFilters.controls['tip_document'].patchValue('');
            // this.formFilters.controls['name_tip_document'].patchValue('');
        }
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterTariExtern(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.tariExtern.filter(tara =>
            this.normalizeString(tara.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterJudeteExtern(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.judeteExtern.filter(judet =>
            this.normalizeString(judet.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }
    // END -- Methods for getting data -- END


    searchDocuments() {
        if (!this.tipDocumenteControl.value) {
            this.tipDocumenteControl.markAsTouched();
            return;
        };
        this.isLoading = true;

        const data_inregistrare = this.formFilters.value.data_inregistrare;

        const payload = {
            conex_docs: this.conexeDocuments.map(doc => doc.id_document),
            filters: {
                ...this.formFilters.value,
                data_inregistrare_formated: data_inregistrare ? formatDate(data_inregistrare, 'yyyy-MM-dd', 'en-US') : '',

                // docData
                document_id: this.docData.id_document,
            }
        };

        // console.log(payload);
        this.dashboardService
            .findDocsIesire(payload)
            .pipe(
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.selectedDocuments = results.data.map(document => {
                        return { ...document, selected: false }
                    });
                    this.selectedDocumentsNr = 0;
                    this.verifySelectedDocs();
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    changeView() {
        this.showSelectedDocs = !this.showSelectedDocs;
    }

    refresh() {
        this.formFilters.patchValue({
            id_serie: -1,
            destinatar: null,
            numar_document: null,
            data_inregistrare: '',
            tip_document: null,
            // name_tip_document: '',
            cnp_cui: '',
        });
        this.entitatiFiltersControl.patchValue('');
        this.tipDocumenteControl.patchValue('');
        this.tipDocumenteControl.markAsUntouched();

        this.selectedDocuments.length = 0;
        this.selectedDocumentsNr = 0;
    }

    selectDocument(index: number) {
        this.selectedDocuments[index].selected = !this.selectedDocuments[index].selected;

        if (this.selectedDocuments[index].selected) {
            this.selectedDocumentsNr++;
        } else {
            this.selectedDocumentsNr--;
        }
    }

    selectAllDocuments() {
        if (this.selectedDocumentsNr !== this.selectedDocuments.length) {
            this.selectedDocuments.forEach(doc => (doc.selected = true));
            this.selectedDocumentsNr = this.selectedDocuments.length;
        } else {
            this.selectedDocuments.forEach(doc => (doc.selected = false));
            this.selectedDocumentsNr = 0;
        }
    }

    addDocumentsToConexe() {
        this.selectedDocuments.forEach(doc => {
            // Check if a selected doc doesn't already exist in conexeDocuments and add it
            if (doc.selected && !this.conexeDocuments.some(conexeDoc => conexeDoc.id_document === doc.id_document)) {
                const newDoc: DocumentDataIesire = { ...doc };
                this.conexeDocuments.push(newDoc);
            }
        });

        this.showSelectedDocs = true;
    }

    refreshConexeDocs() {
        this.conexeDocuments.length = 0;
        this.verifySelectedDocs();
    }

    deleteConexeDoc(index: number) {
        this.conexeDocuments.splice(index, 1);
        this.verifySelectedDocs();
    }

    verifySelectedDocs() {
        const conexeSet = new Set();
        this.conexeDocuments.forEach(conDoc => conexeSet.add(conDoc.id_document));

        this.selectedDocuments.forEach(selDoc => {
            if (conexeSet.has(selDoc.id_document) && selDoc.selected === false) {
                selDoc.selected = true;
                this.selectedDocumentsNr++;
            } else if (!conexeSet.has(selDoc.id_document) && selDoc.selected === true) {
                selDoc.selected = false;
                this.selectedDocumentsNr--;
            }
        })
    }

    areFormsValid() {
        this.form.markAllAsTouched();
        this.form.updateValueAndValidity();
        this.formExtern.markAllAsTouched();
        this.formExtern.updateValueAndValidity();

        this.entitatiExternControl.markAsTouched();
        this.tariExternControl.markAsTouched();
        this.judeteExternControl.markAsTouched();
        this.localitatiExternControl.markAsTouched();
        this.straziExternControl.markAsTouched();

        if (
            this.form.invalid ||
            this.formExtern.invalid
        ) {
            return false;
        } else {
            return true;
        }
    }

    submitForm(generate: number) {
        if (this.areFormsValid()) {
            Swal.fire({
                title: helper.dialogConfig.commonTitles.areYouSure,
                text: 'Vă rugăm să confirmați acest proces!',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: helper.dialogConfig.buttonLabels.close,
                confirmButtonColor: helper.dialogConfig.colorButtons.standard,
                confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
                reverseButtons: true,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.storeAWB(generate);
                }
            });
        } else {
            Swal.fire({
                title: helper.dialogConfig.headers.error,
                text: 'Verificați din nou câmpurile obligatorii şi validitatea informațiilor.',
                icon: 'error',
                confirmButtonText: helper.dialogConfig.buttonLabels.close
            });
        };
    }

    storeAWB(generate: number) {
        this.isLoading = true;

        const regDate = this.docData.reg_date; // '26.11.2025 16:49'
        let regDateObj;

        try {
            const [datePart, timePart] = regDate.split(' ');
            const [day, month, year] = datePart.split('.').map(Number);
            // const [hours, minutes] = timePart.split(':').map(Number);
            regDateObj = new Date(year, month - 1, day)
        } catch {
            console.error('Wrong reg_date format', regDate);
            regDateObj = regDate;
        }

        const dataAwb = {
            ...this.form.value,
            extern_emitent: this.formExtern.value,
            generate, // 1 - generat direct, 0 - salvat,

            // docData
            id_document: this.docData.id_document,
            numar: this.docData.reg_number,
            date: regDateObj,
            user_id: this.docData.id_user,
        };

        const payload = {
            dataAwb,
            document_ids: this.conexeDocuments.map(doc => doc.id_document),
        }

        // Update or store awb
        const routeType = this.awbData ? this.dashboardService.updateAWB(this.awbData.id, payload) : this.dashboardService.storeAWB(payload);
        routeType
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: generate === 1 ? 'AWB generat' : 'AWB salvat',
                        icon: 'success',
                        confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        showLoaderOnConfirm: true,
                        // reverseButtons: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.dialogRef.close({ success: true });
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
